export default __webpack_public_path__ + "static/media/2380_mounted.88050631.jpg";